export default {
  "auth.login": "Connexion",
  "auth.register": "S'inscrire",
  "auth.email": "Adresse e-mail",
  "auth.password": "Mot de passe",
  "auth.logout": "Déconnexion",
  "auth.loginFailed": "Échec de la connexion",
  "auth.registerFailed": "Échec de l'inscription",
  "nav.dashboard": "Tableau de bord d'évaluation",
  "nav.activeEvaluations": "Évaluations en cours",
  "nav.completedEvaluations": "Évaluations terminées",
  "nav.createNew": "Créer une nouvelle évaluation",
  "nav.projectMerge": "Fusion de projet",
  "nav.share": "Paramètres de partage",
  "nav.copy": "Copier",
  "nav.delete": "Supprimer",
  "nav.settings": "Paramètres",
  "menu.language": "Paramètres de langue",
  "menu.colorPalette": "Palette de couleurs",
  "status.inProgress": "En cours",
  "status.completed": "Terminé",
  "status.untitled": "Évaluation sans titre",
  "stats.subjects": "Sujets",
  "stats.criteria": "Critères",
  "stats.progress": "Progrès",
  "step.criteriaExtraction": "Extraction des critères",
  "step.comparison": "Classons-les par ordre de qualité",
  "step.subjectRegistration": "Enregistrement des sujets",
  "form.evaluationPolicy": "Politique d'évaluation",
  "form.policyDescription": "Politique d'évaluation et points clés",
  "form.policyPlaceholder": "Exemple : Mettre l'accent sur la structure logique et évaluer la créativité et l'originalité",
  "btn.aiExtraction": "Extraction IA des critères",
  "btn.manualAdd": "Ajouter des critères manuellement",
  "btn.next": "Suivant",
  "btn.back": "Retour",
  "plan.free": "Plan gratuit",
  "plan.professional": "Professionnel",
  "plan.business": "Entreprise",
  "plan.school": "École",
  "plan.unlimitedProjects": "Projets illimités",
  "plan.prioritySupport": "Support prioritaire",
  "plan.dataExport": "Exportation de données",
  "plan.monthlyRenewal": "Renouvellement automatique mensuel",
  "plan.cancelAnytime": "Annuler à tout moment",
  "plan.paymentFailed": "Échec du lancement du paiement",
  "confirm.delete": "Êtes-vous sûr de vouloir supprimer ? Cette action ne peut pas être annulée",
  "alert.appUpdate": "Mise à jour de l'application détectée",
  "alert.projectLimit": "Vous avez atteint la limite de création de projets d'évaluation",
  "common.loading": "Chargement...",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.confirm": "Confirmer",
  "common.error": "Erreur",
  "common.success": "Succès",
  "date.today": "Aujourd'hui",
  "date.yesterday": "Hier",
  "date.thisWeek": "Cette semaine",
  "date.lastWeek": "La semaine dernière",
  "error.dashboardLoad": "Erreur de chargement du tableau de bord",
  "error.serverUnavailable": "Impossible de se connecter au serveur. Veuillez réessayer plus tard",
  "error.evaluationLimit": "Échec de la vérification de la limite d'évaluation",
  "error.loadingData": "Erreur de chargement",
  "error.copyFailed": "Erreur de copie",
  "error.deleteFailed": "Échec de la suppression",
  "error.copyProcess": "Une erreur s'est produite pendant le processus de copie",
  "error.deleteProcess": "Une erreur s'est produite pendant le processus de suppression",
  "error.sharingUpdate": "Échec de la mise à jour des paramètres de partage",
  "msg.loadingDashboard": "Chargement du tableau de bord...",
  "msg.retry": "Réessayer",
  "msg.projectLimitReached": "Vous avez atteint la limite de création de projets d'évaluation",
  "msg.upgradeToProPlan": "Veuillez passer au plan PRO",
  "msg.cannotCreateProject": "Impossible de créer un projet d'évaluation",
  "msg.freeLastProject": "Le plan gratuit permet jusqu'à 1 projet d'évaluation. C'est votre dernier créneau disponible.",
  "msg.untitledProject": "Projet d'évaluation sans titre",
  "msg.welcome": "Bienvenue",
  "msg.welcomeWithName": "Bienvenue, {{name}}",
  "msg.created": "Créé",
  "msg.updated": "Mis à jour",
  "msg.completed": "terminé",
  "copy.title": "Création d'une copie de \"{{title}}\"",
  "copy.newTitle": "Entrez un nouveau titre (laissez vide pour \"Titre original (Copie)\")",
  "progress.completed": "terminé",
  "common.initializing": "Initialisation de l'application...",
  "common.connecting": "Connexion...",
  "common.processing": "Traitement...",
  "common.required": "Requis",
  "common.close": "Fermer",
  "common.preview": "Aperçu",
  "common.edit": "Modifier",
  "common.details": "Détails",
  "common.position": "Position",
  "common.rank": "Rang",
  "common.placed": "Placé",
  "common.characters": "caractères",
  "common.items": "éléments",
  "common.folders": "Dossiers",
  "common.files": "Fichiers",
  "common.openInNewTab": "Ouvrir dans un nouvel onglet",
  "common.next": "Suivant",
  "common.prev": "Précédent",
  "googleDrive.title": "Importer depuis Google Drive",
  "googleDrive.connect": "Se connecter à Google Drive",
  "googleDrive.description": "Pour importer des cibles d'évaluation depuis Google Drive en lot, veuillez d'abord vous connecter avec votre compte Google.",
  "googleDrive.signIn": "Se connecter avec un compte Google",
  "modal.closeModal": "Fermer la modale",
  "invitation.invalid": "Jeton d'invitation invalide",
  "invitation.accepted": "Invitation acceptée",
  "invitation.failed": "Échec de l'acceptation de l'invitation",
  "invitation.title": "Invitation au projet d'évaluation",
  "invitation.accept": "Accepter l'invitation",
  "collaboration.viewResults": "Voir les résultats d'évaluation",
  "collaboration.addComments": "Ajouter des commentaires",
  "collaboration.downloadData": "Télécharger les données",
  "collaboration.editCriteria": "Modifier les critères d'évaluation",
  "collaboration.manageProject": "Gérer le projet",
  "autoSave.settings": "Paramètres de sauvegarde automatique",
  "autoSave.interval": "Intervalle de sauvegarde",
  "autoSave.15seconds": "15 secondes",
  "autoSave.30seconds": "30 secondes",
  "autoSave.1minute": "1 minute",
  "autoSave.2minutes": "2 minutes",
  "autoSave.5minutes": "5 minutes",
  "autoSave.saveNow": "Sauvegarder maintenant",
  "autoSave.saved": "Sauvegardé",
  "autoSave.helpShort": "Sauvegarder fréquemment avec des intervalles courts",
  "autoSave.helpMedium": "Fréquence de sauvegarde équilibrée",
  "autoSave.helpLong": "Économiser les ressources avec des intervalles plus longs",
  "weight.title": "Configuration du poids d'évaluation globale",
  "weight.description": "Veuillez définir le poids pour chaque critère d'évaluation. Le poids total sera ajusté à 100%.",
  "weight.equalDistribution": "Distribution égale",
  "weight.criterion": "Critère d'évaluation",
  "weight.weight": "Poids (%)",
  "weight.maxScore": "Score maximum",
  "weight.saveSettings": "Enregistrer les paramètres",
  "preview.title": "Aperçu de {{title}}",
  "preview.iframeBlocked": "Certains sites peuvent bloquer l'affichage dans les iframes.",
  "preview.showPreview": "Afficher l'aperçu",
  "preview.editDetails": "Modifier les détails",
  "preview.available": "Aperçu disponible",
  "googleDrive.myDrive": "Mon Drive",
  "googleDrive.emptyFolder": "Ce dossier est vide",
  "googleDrive.filesSelected": " fichiers sélectionnés",
  "googleDrive.importSelected": "Importer les fichiers sélectionnés",
  "dashboard.projectLimitReached": "Vous avez atteint la limite de création de projets d'évaluation ({count} projets). Veuillez passer au plan PRO.",
  "dashboard.cannotCreateProject": "Impossible de créer un projet d'évaluation.",
  "dashboard.freeLastProject": "Le plan gratuit permet jusqu'à 1 projet d'évaluation. C'est votre dernier créneau disponible.",
  "dashboard.evaluationLimitCheckFailed": "Échec de la vérification de la limite d'évaluation.",
  "dashboard.loadingError": "Erreur de chargement: {{message}}",
  "dashboard.copyError": "Erreur de copie: {{message}}",
  "dashboard.copyProcessError": "Une erreur s'est produite pendant le processus de copie",
  "dashboard.deleteError": "Erreur de suppression: {{message}}",
  "dashboard.deleteProcessError": "Une erreur s'est produite pendant le processus de suppression",
  "dashboard.shareSettingsUpdateFailed": "Échec de la mise à jour des paramètres de partage",
  "dashboard.copyProjectTitle": "Création d'une copie de \"{{title}}\".",
  "dashboard.copyProjectPrompt": "Entrez un nouveau titre (laissez vide pour \"Titre original (Copie)\"):",
  "dashboard.deleteConfirm": "Supprimer \"{{title}}\"? Cette action ne peut pas être annulée.",
  "dashboard.statusUnknown": "Inconnu",
  "dashboard.collaborators": "{{count}} collaborateurs",
  "dashboard.menu": "Menu",
  "dashboard.shareSettings": "Paramètres de partage",
  "dashboard.copy": "Copier",
  "dashboard.delete": "Supprimer",
  "dashboard.subjects": "Sujets",
  "dashboard.criteria": "Critères",
  "dashboard.progress": "Progrès",
  "dashboard.completed": "Terminé",
  "dashboard.created": "Créé:",
  "dashboard.updated": "Mis à jour:",
  "dashboard.loadingDashboard": "Chargement du tableau de bord...",
  "dashboard.retry": "Réessayer",
  "dashboard.title": "Tableau de bord d'évaluation",
  "dashboard.projectMerge": "Intégration de projet",
  "dashboard.createNew": "Créer une nouvelle évaluation",
  "dashboard.inProgressTab": "Évaluations en cours",
  "dashboard.completedTab": "Évaluations terminées",
  "dashboard.noInProgress": "Aucune évaluation en cours",
  "dashboard.noInProgressDesc": "Commençons par créer une nouvelle évaluation.",
  "dashboard.noCompleted": "Aucune évaluation terminée",
  "dashboard.noCompletedDesc": "Les évaluations terminées apparaîtront ici.",
  "dashboard.untitledProject": "Projet d'évaluation sans titre",
  "dashboard.sharing": "Partage",
  "billing.paymentCompleted": "Paiement Terminé",
  "billing.subscriptionCompleted": "Inscription à l'abonnement terminée. Merci d'utiliser notre service \!",
  "billing.paymentCanceled": "Le paiement a été annulé. Veuillez réessayer ou nous contacter.",
  "settings.backToDashboard": "← Retour au Tableau de Bord",
  "userSettings.title": "Paramètres Utilisateur",
  "userSettings.description": "Gérez vos informations de compte et paramètres de sécurité.",
  "userSettings.basicInfo": "Informations de Base",
  "userSettings.username": "Nom d'utilisateur",
  "userSettings.usernamePlaceholder": "Entrez le nom d'utilisateur",
  "userSettings.email": "Adresse Email",
  "userSettings.emailPlaceholder": "exemple@domaine.com",
  "userSettings.displayName": "Nom d'Affichage",
  "userSettings.displayNamePlaceholder": "Entrez le nom d'affichage (optionnel)",
  "userSettings.displayNameHelp": "Nom affiché aux autres utilisateurs.",
  "userSettings.saving": "Enregistrement...",
  "userSettings.saveSettings": "Enregistrer les Paramètres",
  "userSettings.securitySettings": "Paramètres de Sécurité",
  "userSettings.securityMode": "Mode Sécurité",
  "userSettings.securityModeDescription": "Activez le chiffrement des données pour protéger votre vie privée.",
  "userSettings.securityOn": "Activé",
  "userSettings.securityOff": "Désactivé",
  "userSettings.securityCode": "Code de Sécurité",
  "userSettings.hide": "Masquer",
  "userSettings.show": "Afficher",
  "userSettings.encryptionCode": "Code de Chiffrement",
  "userSettings.recoveryCode": "Code de Récupération",
  "userSettings.copy": "Copier",
  "userSettings.generateNewKeys": "Générer de Nouvelles Clés",
  "userSettings.manualKeyInput": "Saisie Manuelle de Clé",
  "userSettings.viewSharedData": "Voir les Données Partagées",
  "userSettings.viewSharedDataDescription": "Saisissez les clés pour voir les données chiffrées partagées par d'autres utilisateurs.",
  "userSettings.inputEncryptionKey": "Saisir la Clé de Chiffrement",
  "userSettings.manualKeyTitle": "Saisie Manuelle de Clé de Chiffrement",
  "userSettings.manualKeyDescription": "Entrez la paire de clés de chiffrement partagées.",
  "userSettings.publicKey": "Clé Publique",
  "userSettings.publicKeyPlaceholder": "Entrez la clé publique",
  "userSettings.privateKey": "Clé Privée",
  "userSettings.privateKeyPlaceholder": "Entrez la clé privée",
  "userSettings.keyWarning": "Attention :",
  "userSettings.keyWarningText": "Ces clés sont confidentielles. Stockez-les dans un endroit sécurisé.",
  "userSettings.setKeys": "Définir les Clés",
  "userSettings.requiredFieldsError": "Le nom d'utilisateur et l'adresse email sont des champs obligatoires.",
  "userSettings.enableSecurityModeConfirm": "Activer le mode sécurité ? Le chiffrement des données commencera.",
  "userSettings.securityModeEnabled": "Le mode sécurité a été activé.",
  "userSettings.securityModeDisabled": "Le mode sécurité a été désactivé.",
  "userSettings.generateNewKeysConfirm": "Générer de nouvelles clés ? Les clés existantes deviendront invalides.",
  "userSettings.newKeysGenerated": "De nouvelles clés ont été générées.",
  "userSettings.bothKeysRequired": "Les clés publique et privée sont toutes deux requises.",
  "userSettings.invalidPublicKeyFormat": "Le format de la clé publique est invalide.",
  "userSettings.invalidPrivateKeyFormat": "Le format de la clé privée est invalide.",
  "userSettings.keysSet": "Les clés ont été définies.",
  "userSettings.keySetError": "Une erreur s'est produite lors de la définition des clés.",
  "userSettings.copiedToClipboard": "Copié dans le presse-papiers.",
  "userSettings.copyFailed": "Échec de la copie.",
  "billing.currentPlan": "Plan Actuel",
  "billing.status.developerAccess": "Accès Développeur",
  "billing.status.active": "Actif",
  "billing.status.free": "Gratuit",
  "billing.nextRenewalDate": "Date de Renouvellement Automatique",
  "billing.autoRenewalNote": "(sera automatiquement facturé)",
  "billing.expiresAt": "Expire le",
  "billing.cancelNotice": "Cet abonnement sera annulé à la fin de la période actuelle.",
  "billing.cancelSubscription": "Annuler l'Abonnement",
  "billing.cancelSubscriptionConfirm": "Annuler l'abonnement ? Il sera annulé à la fin de la période actuelle.",
  "billing.cancelSubscriptionSuccess": "L'annulation de l'abonnement a été traitée. Il sera annulé à la fin de la période actuelle.",
  "billing.cancelSubscriptionFailed": "Échec de l'annulation.",
  "billing.forIndividual": "(Pour Particulier)",
  "billing.forBusiness": "(Pour Entreprise)",
  "billing.forSchool": "(Pour École)",
  "billing.free": "Gratuit",
  "billing.month": "mois",
  "billing.year": "année",
  "billing.features": "Fonctionnalités",
  "billing.upgrade": "Mettre à Niveau",
  "billing.customQuote": "Devis Personnalisé",
  "billing.flexibleCustomization": "Support de Personnalisation Flexible",
  "billing.educationalDiscount": "Tarif Spécial Institution Éducative",
  "billing.requestCorporateQuote": "Demander un Devis Entreprise",
  "billing.requestAcademicQuote": "Demander un Devis Académique",
  "billing.aboutBilling": "À Propos de la Facturation",
  "billing.autoRenewal": "Renouvellement Automatique",
  "billing.autoRenewalDescription": "Les plans mensuels sont automatiquement renouvelés le même jour chaque mois",
  "billing.nextRenewalDateDescription": "Les abonnés actuels peuvent vérifier dans la section \"Plan Actuel\" ci-dessus",
  "billing.cancellation": "Annulation",
  "billing.cancellationDescription": "Peut être annulé à tout moment, le service s'arrêtera à la fin de la période actuelle",
  "billing.payment": "Paiement",
  "billing.paymentDescription": "Nous utilisons le système de paiement sécurisé de Stripe",
  "billing.receipt": "Reçu",
  "billing.receiptDescription": "Envoyé automatiquement par email après la finalisation du paiement",
  "billing.aiUsageLimitation": "Avis de limitation d'utilisation de l'IA",
  "billing.enterprise": "Pour les Entreprises",
  "billing.education": "Pour l'Éducation",
  "billing.feature.limited_projects": "Jusqu'à 3 Projets",
  "billing.feature.unlimited_projects": "Projets Illimités",
  "billing.feature.unlimited_collaborators": "Collaborateurs Illimités",
  "billing.feature.basic_rubric": "Fonctionnalités de Rubrique de Base",
  "billing.feature.advanced_rubric": "Fonctionnalités de Rubrique Avancées",
  "billing.feature.ai_assistance": "Fonctionnalités d'Assistance IA",
  "billing.feature.priority_support": "Support Prioritaire",
  "billing.feature.data_export": "Exportation de Données",
  "billing.feature.custom_templates": "Modèles Personnalisés",
  "billing.feature.pdf_export": "Exportation PDF",
  "billing.feature.limited_pdf_export": "Exportation PDF (5 par jour)",
  "billing.feature.no_csv_export": "Exportation CSV : Non disponible",
  "billing.feature.allProfessionalFeatures": "Toutes les Fonctionnalités du Plan Professionnel",
  "billing.feature.unlimitedUsers": "Nombre Illimité d'Utilisateurs",
  "billing.feature.dedicatedSupportAgent": "Agent de Support Dédié",
  "billing.feature.customIntegrationAPI": "Intégration Personnalisée et Développement API",
  "billing.feature.customBranding": "Support de Marque Personnalisée",
  "billing.feature.singleSignOn": "Authentification Unique (SSO)",
  "billing.feature.auditLogSecurity": "Journal d'Audit et Fonctionnalités de Sécurité",
  "billing.feature.onPremiseDeployment": "Support de Déploiement sur Site",
  "billing.feature.trainingImplementationSupport": "Support de Formation et d'Implémentation",
  "billing.feature.unlimitedStudentFacultyAccounts": "Comptes Étudiants et Professeurs Illimités",
  "billing.feature.educationalInstitutionSpecialPricing": "Tarification Spéciale Institution Éducative",
  "billing.feature.classroomPracticalTemplates": "Modèles de Classe et Pratiques",
  "billing.feature.gradeManagementSystemIntegration": "Intégration du Système de Gestion des Notes",
  "billing.feature.learningAnalyticsReporting": "Analyses d'Apprentissage et Rapports",
  "billing.feature.parentGuardianSharingFeature": "Fonctionnalité de Partage Parents et Tuteurs",
  "billing.feature.educationalInstitutionDedicatedSupport": "Support Dédié Institution Éducative",
  "billing.feature.implementationTrainingTeacherTraining": "Formation d'Implémentation et Formation des Enseignants",
  "quote.title": "Demande de Devis Plan Entreprise",
  "quote.submit": "Demander un Devis",
  "quote.sections.contactInfo": "Informations de Contact",
  "quote.sections.usagePlan": "Plan d'Utilisation",
  "quote.sections.budgetRequirements": "Budget et Exigences",
  "quote.fields.name": "Nom",
  "quote.fields.position": "Poste",
  "quote.fields.phone": "Numéro de Téléphone",
  "quote.fields.expectedUsers": "Nombre d'Utilisateurs Attendu",
  "quote.fields.timeline": "Calendrier de Mise en Œuvre",
  "quote.fields.useCase": "Cas d'Usage",
  "quote.fields.currentSolution": "Méthode/Outil d'Évaluation Actuel",
  "quote.fields.budget": "Fourchette de Budget",
  "quote.fields.requirements": "Fonctionnalités/Exigences Requises",
  "quote.fields.message": "Demandes/Questions Supplémentaires",
  "quote.placeholders.currentSolution": "Veuillez décrire les méthodes ou outils d'évaluation actuels que vous utilisez",
  "quote.placeholders.message": "Veuillez nous faire savoir si vous avez des demandes ou questions supplémentaires",
  "quote.timeline.immediate": "Immédiatement",
  "quote.timeline.oneMonth": "Dans 1 mois",
  "quote.timeline.threeMonths": "Dans 3 mois",
  "quote.timeline.sixMonths": "Dans 6 mois",
  "quote.timeline.oneYear": "Dans 1 an",
  "quote.timeline.undecided": "Indécis",
  "quote.success.title": "Demande de devis reçue",
  "quote.error.submitFailed": "Échec de la soumission de la demande de devis",
  "quote.error.submitFailedRetry": "Échec de la soumission de la demande de devis. Veuillez réessayer plus tard.",
  "common.pleaseSelect": "Veuillez sélectionner",
  "common.other": "Autre",
  "common.submitting": "Soumission...",
  "quote.corporate.subtitle": "Pour les Entreprises",
  "quote.corporate.description": "Nous proposons des solutions d'entreprise personnalisables adaptées aux besoins de votre société. Veuillez remplir le formulaire ci-dessous et n'hésitez pas à nous contacter.",
  "quote.corporate.sections.companyInfo": "Informations sur l'Entreprise",
  "quote.corporate.fields.companyName": "Nom de l'Entreprise",
  "quote.corporate.fields.department": "Département",
  "quote.corporate.userCounts.small": "10-50 utilisateurs",
  "quote.corporate.userCounts.medium": "51-100 utilisateurs",
  "quote.corporate.userCounts.large": "101-300 utilisateurs",
  "quote.corporate.userCounts.xlarge": "301-500 utilisateurs",
  "quote.corporate.userCounts.xxlarge": "501-1 000 utilisateurs",
  "quote.corporate.userCounts.enterprise": "1 000+ utilisateurs",
  "quote.corporate.budget.under500k": "Moins de 5 000 €/mois",
  "quote.corporate.budget.500k1m": "5 000-10 000 €/mois",
  "quote.corporate.budget.1m3m": "10 000-30 000 €/mois",
  "quote.corporate.budget.3m5m": "30 000-50 000 €/mois",
  "quote.corporate.budget.over5m": "Plus de 50 000 €/mois",
  "quote.corporate.placeholders.useCase": "ex. : système d'évaluation interne, évaluation d'entretien de recrutement, mesure de l'efficacité de la formation",
  "quote.corporate.formNote": "Les informations que vous fournissez seront gérées de manière appropriée conformément à notre politique de confidentialité.",
  "quote.success.corporate.message": "Merci pour votre demande. Notre représentant vous contactera dans les 2 jours ouvrables.",
  "quote.corporate.requirements.sso": "Authentification Unique (SSO)",
  "quote.corporate.requirements.activeDirectory": "Intégration Active Directory",
  "quote.corporate.requirements.customBranding": "Marque Personnalisée",
  "quote.corporate.requirements.dedicatedServer": "Serveur Dédié/Déploiement sur Site",
  "quote.corporate.requirements.apiIntegration": "Intégration API/Intégration Personnalisée",
  "quote.corporate.requirements.auditLogs": "Journaux d'Audit/Fonctionnalités de Sécurité",
  "quote.corporate.requirements.multilingual": "Support Multi-langues",
  "quote.corporate.requirements.support24": "Support 24/7",
  "quote.corporate.requirements.training": "Formation de Mise en Œuvre",
  "quote.corporate.requirements.dataMigration": "Support de Migration de Données",
  "quote.academic.subtitle": "Pour les Écoles et Institutions Éducatives",
  "quote.academic.description": "Nous proposons des solutions spécialement conçues pour les institutions éducatives. Des prix spéciaux et des personnalisations de fonctionnalités spécifiques à l'éducation sont disponibles.",
  "quote.academic.sections.institutionInfo": "Informations de l'Institution Éducative",
  "quote.academic.fields.institutionName": "Nom de l'École/Institution",
  "quote.academic.fields.institutionType": "Type d'Institution",
  "quote.academic.fields.department": "Faculté/Département",
  "quote.academic.fields.positionTitle": "Poste/Titre",
  "quote.academic.fields.expectedUsers": "Nombre d'Utilisateurs Attendu (Professeurs/Personnel)",
  "quote.academic.fields.studentCount": "Nombre d'Étudiants",
  "quote.academic.fields.currentSolution": "Méthode/Système d'Évaluation Actuel",
  "quote.academic.fields.budgetAnnual": "Fourchette de Budget (Annuel)",
  "quote.academic.institutionTypes.university": "Université",
  "quote.academic.institutionTypes.college": "Collège/Collège Communautaire",
  "quote.academic.institutionTypes.highSchool": "Lycée",
  "quote.academic.institutionTypes.juniorHigh": "Collège",
  "quote.academic.institutionTypes.elementary": "École Primaire",
  "quote.academic.institutionTypes.vocational": "École de Formation Professionnelle",
  "quote.academic.userCounts.small": "5-20 utilisateurs",
  "quote.academic.userCounts.medium": "21-50 utilisateurs",
  "quote.academic.userCounts.large": "51-100 utilisateurs",
  "quote.academic.userCounts.xlarge": "101-300 utilisateurs",
  "quote.academic.userCounts.xxlarge": "301-500 utilisateurs",
  "quote.academic.userCounts.enterprise": "500+ utilisateurs",
  "quote.academic.studentCounts.under100": "Moins de 100",
  "quote.academic.studentCounts.small": "100-500",
  "quote.academic.studentCounts.medium": "501-1 000",
  "quote.academic.studentCounts.large": "1 001-3 000",
  "quote.academic.studentCounts.xlarge": "3 001-10 000",
  "quote.academic.studentCounts.xxlarge": "10 000+",
  "quote.academic.timeline.nextSemester": "Prochain Semestre",
  "quote.academic.timeline.nextYear": "Année Académique Suivante",
  "quote.academic.budget.under1m": "Moins de 10 000 €",
  "quote.academic.budget.1m3m": "10 000-30 000 €",
  "quote.academic.budget.3m5m": "30 000-50 000 €",
  "quote.academic.budget.5m10m": "50 000-100 000 €",
  "quote.academic.budget.over10m": "100 000 €+",
  "quote.academic.placeholders.position": "ex. : Professeur, Professeur Assistant, Personnel Administratif",
  "quote.academic.placeholders.useCase": "ex. : évaluation d'étudiants, évaluation pratique/compétences, formation du personnel, évaluation de cours",
  "quote.academic.placeholders.currentSolution": "Veuillez décrire les méthodes ou systèmes d'évaluation actuels que vous utilisez",
  "quote.academic.placeholders.message": "Veuillez nous faire savoir si vous avez des exigences spécifiques aux institutions éducatives ou des questions",
  "quote.academic.formNote": "Les informations que vous fournissez seront gérées de manière appropriée conformément à notre politique de confidentialité.",
  "quote.success.academic.message": "Merci pour votre demande. Notre spécialiste des institutions éducatives vous contactera dans les 2 jours ouvrables.",
  "quote.academic.requirements.lmsIntegration": "Intégration Système de Gestion de l'Apprentissage (LMS)",
  "quote.academic.requirements.gradeManagement": "Intégration Système de Gestion des Notes",
  "quote.academic.requirements.studentPortal": "Intégration Portail Étudiant",
  "quote.academic.requirements.parentSharing": "Fonctionnalités de Partage Parents/Tuteurs",
  "quote.academic.requirements.courseTemplates": "Modèles de Cours/Pratiques",
  "quote.academic.requirements.learningAnalytics": "Analyses d'Apprentissage/Rapports",
  "quote.academic.requirements.multilingualEng": "Support Multi-langues (Anglais, etc.)",
  "quote.academic.requirements.teacherTraining": "Formation des Enseignants",
  "quote.academic.requirements.implementationSupport": "Support de Mise en Œuvre/Formation",
  "common.backToDashboard": "Retour au Tableau de Bord",

  // Report Generation
  "report.title": "Génération de Rapport",
  "report.evaluationNotice": "Rapport d'Évaluation",
  "report.evaluationDate": "Date d'Évaluation",
  "report.criteriaEvaluation": "Évaluation par Critères",
  "report.overallEvaluation": "Évaluation Globale",
  "report.comments": "Commentaires",
  "report.commentsPlaceholder": "Entrez les détails ou commentaires...",
  "report.commentsEmpty": "Aucun détail saisi",
  "report.editComments": "Modifier les Détails",
  "report.showPreview": "Afficher l'Aperçu",
  "report.hidePreview": "Masquer l'Aperçu",
  "report.preview": "Aperçu",
  "report.criterionColumn": "Critère",
  "report.gradeColumn": "Note",
  "report.rankColumn": "Rang",
  "report.descriptionColumn": "Description",
  "report.nthGrade": "Note {{grade}}",
  "report.topPercentile": "Top {{percent}}%",
  "report.rankFormat": "{{position}}/{{total}}",
  "report.noDescription": "-",
  "report.personalEvaluation": "Évaluation Personnelle",
  "report.groupAverage": "Moyenne du Groupe",
  "report.summary": "Résumé",
  "report.enableOverallEvaluation": "Activer l'Évaluation Globale",
  "report.disableOverallEvaluation": "Désactiver l'Évaluation Globale",
  "report.pointsFormat": "{{score}} points / {{maxScore}} points",
  "report.percentageFormat": "({{percentage}}%)",
  "report.configureWeights": "Configurer les Pondérations",
  "report.footerNote": "※ Cette évaluation présente à la fois des évaluations référentielles et normatives.",
  "report.rubricTitle": "Critères d'Évaluation (Rubrique)",
  "report.noRubric": "Aucune rubrique n'a été générée",
  "report.noSubjects": "Aucun sujet d'évaluation n'a été enregistré.",
  "report.print": "Imprimer",
  "report.downloadPdf": "Télécharger PDF",
  "report.downloadPdfLimitReached": "Télécharger PDF (Limite Atteinte)",
  "report.pdfExportLimit": "Limite d'exportation PDF ({{count}} fichiers par jour) atteinte. Veuillez passer à {{planName}} ou réessayer demain.",
  "report.pdfExportError": "L'exportation PDF n'est pas disponible.",
  "report.pdfGenerationFailed": "La génération PDF a échoué.",
  "report.pdfGenerationError": "Erreur de génération PDF:",
  "report.reportCardNotFound": "Bulletin de notes introuvable.",
  "report.pdfExportStatus": "Exportations PDF d'aujourd'hui: {{current}}/{{max}}",
  "report.pdfExportRemaining": " ({{remaining}} restantes)",
  "report.pdfExportLimitReached": "Limite d'exportation quotidienne atteinte. {{planName}} offre des exportations illimitées.",
  "report.backToRubric": "Retour à la Génération de Rubrique",
  "autoSave.unsaved": "Non sauvegardé",
  "autoSave.savedSecondsAgo": "Sauvegardé il y a {{seconds}} secondes",
  "autoSave.savedMinutesAgo": "Sauvegardé il y a {{minutes}} minutes",
  "autoSave.savedAtTime": "Sauvegardé à {{time}}",
  "autoSave.saving": "Sauvegarde...",
  "autoSave.unsavedChanges": "Modifications non sauvegardées",
  "autoSave.autoSaveOn": "Sauvegarde automatique : ACTIVÉE",
  "plan.pro": "PRO",
  "billing.businessPrice": "25€~",
  "billing.schoolPrice": "7€~",
  "billing.pricePerMonth": "/mois/personne",

  // Steps
  "steps.process.ariaLabel": "Processus d'évaluation",
  "steps.productRegistration.title": "Enregistrer les sujets",
  "steps.productRegistration.description": "Enregistrer les sujets à évaluer",
  "steps.criteriaExtraction.title": "Extraire les critères",
  "steps.criteriaExtraction.description": "Extraire les critères d'évaluation avec l'IA",
  "steps.comparison.title": "Évaluation comparative",
  "steps.comparison.description": "Positionner relativement",
  "steps.gradeAssignment.title": "Attribution des notes",
  "steps.gradeAssignment.description": "Déterminer les notes finales",
  "steps.rubricGeneration.title": "Générer la rubrique",
  "steps.rubricGeneration.description": "Créer une rubrique avec l'IA",
  "steps.quickEvaluation.title": "Évaluation rapide",
  "steps.quickEvaluation.description": "Compléter l'évaluation facilement",
  "steps.reportGeneration.title": "Générer les rapports",
  "steps.reportGeneration.description": "Créer de beaux bulletins",

  // Criteria Extraction
  "criteriaExtraction.emptyState.title": "Veuillez d'abord enregistrer les sujets d'évaluation",
  "criteriaExtraction.emptyState.description": "Pour extraire des critères, vous devez d'abord enregistrer des sujets d'évaluation.",
  "criteriaExtraction.emptyState.backButton": "Retour à l'enregistrement des sujets",
  "criteriaExtraction.title": "Extraction des critères",
  "criteriaExtraction.description": "Décrivez les critères que vous souhaitez évaluer. L'IA extraira automatiquement les critères d'évaluation.",
  "criteriaExtraction.policyTitle": "Politique d'évaluation et points clés",
  "criteriaExtraction.policyDescription": "Décrivez spécifiquement les critères que vous souhaitez évaluer. L'IA extraira automatiquement les critères d'évaluation optimaux.",
  "criteriaExtraction.policyLabel": "Politique d'évaluation",
  "criteriaExtraction.policyPlaceholder": "Exemple : Mettre l'accent sur la structure logique, évaluer la créativité et l'originalité, se concentrer sur la faisabilité, etc.",
  "criteriaExtraction.removePolicyTitle": "Supprimer la politique d'évaluation {{index}}",
  "criteriaExtraction.addPolicyButton": "Ajouter une politique d'évaluation",
  "criteriaExtraction.extractButton": "Extraire avec l'IA",
  "criteriaExtraction.extractingButton": "Extraction avec l'IA...",
  "criteriaExtraction.extractedTitle": "Critères d'évaluation extraits",
  "criteriaExtraction.extractedSubtitle": "{{count}} critères d'évaluation ont été extraits. Veuillez vérifier et modifier le contenu.",
  "criteriaExtraction.addCriterionButton": "Ajouter un critère manuellement",
  "criteriaExtraction.newCriterionTitle": "Nouveau critère",
  "criteriaExtraction.newCriterionDescription": "Évaluer sur la base de ce critère",
  "criteriaExtraction.successTitle": "Extraction des critères terminée !",
  "criteriaExtraction.successDescription": "Examinez chaque critère et modifiez-le si nécessaire avant de passer à l'étape suivante.",
  "criteriaExtraction.nextButton": "Vers l'évaluation comparative",
  "criteriaExtraction.prevButton": "Retour à l'enregistrement des sujets",

  // Product Registration
  "productRegistration.title": "Enregistrer les sujets d'évaluation",
  "productRegistration.description": "Enregistrez les sujets à évaluer (rapports d'étudiants, produits, propositions, etc.).",
  "productRegistration.securityNotice": "🔒 Le mode sécurité est activé. Les noms des sujets seront cryptés.",
  "productRegistration.viewToggle.form": "Formulaire",
  "productRegistration.viewToggle.formTitle": "Vue formulaire",
  "productRegistration.viewToggle.table": "Tableau",
  "productRegistration.viewToggle.tableTitle": "Vue tableau",
  "productRegistration.import.drive": "Importer depuis Google Drive",
  "productRegistration.import.driveTitle": "Importer depuis Google Drive",
  "productRegistration.import.driveLabel": "Importer des fichiers depuis Google Drive",
  "productRegistration.import.csv": "Télécharger un fichier CSV",
  "productRegistration.import.csvTitle": "Télécharger un fichier CSV",
  "productRegistration.import.csvLabel": "Télécharger des sujets d'évaluation depuis un fichier CSV",
  "productRegistration.import.template": "Télécharger le modèle CSV",
  "productRegistration.import.templateTitle": "Télécharger le modèle CSV",
  "productRegistration.import.templateLabel": "Télécharger le fichier modèle CSV",
  "productRegistration.import.driveDetail": "Importé depuis Google Drive : {{fileName}}",
  "productRegistration.form.titleLabel": "Nom du sujet",
  "productRegistration.form.titlePlaceholder": "ex. Rapport A, Proposition B, Projet C",
  "productRegistration.form.titleHelp": "Entrez le nom du sujet à évaluer",
  "productRegistration.form.linkLabel": "Lien (Facultatif)",
  "productRegistration.form.linkPlaceholder": "https://drive.google.com/... etc.",
  "productRegistration.form.linkHelp": "Entrez l'URL des matériaux ou fichiers associés si disponibles",
  "productRegistration.form.detailLabel": "Détails et commentaires",
  "productRegistration.form.detailPlaceholder": "Entrez les détails nécessaires à l'évaluation tels que les caractéristiques, le contenu et les informations de fond.\nExemple : \"Version brouillon de la thèse de fin d'études, proposition de revitalisation régionale créée par un étudiant de 3e année en économie\"",
  "productRegistration.form.detailHelp": "Veuillez fournir des détails spécifiques sur le contenu et les caractéristiques pour aider les évaluateurs à évaluer correctement",
  "productRegistration.form.addButton": "Ajouter un sujet",
  "productRegistration.list.title": "Sujets enregistrés ({{count}})",
  "productRegistration.list.encryptedBadge": "🔒 Crypté",
  "productRegistration.list.encrypted": "Crypté",
  "productRegistration.edit.titlePlaceholder": "Entrez le nom du sujet",
  "productRegistration.edit.linkPlaceholder": "Entrez l'URL du lien",
  "productRegistration.edit.detailPlaceholder": "Entrez les détails et commentaires",
  "productRegistration.edit.save": "Enregistrer",
  "productRegistration.edit.cancel": "Annuler",
  "productRegistration.preview": "Aperçu de {{title}}",
  "productRegistration.edit": "Modifier {{title}}",
  "productRegistration.delete": "Supprimer {{title}}",
  "productRegistration.googleDrive.importedDetail": "Importé depuis Google Drive : {{name}}",
  "productRegistration.csv.header1": "Nom du sujet",
  "productRegistration.csv.detail1": "Description détaillée",
  "productRegistration.csv.validationError": "Le fichier CSV doit avoir les colonnes reviewTitle et reviewComment. Veuillez télécharger le modèle et vérifier.",
  "productRegistration.error.encryptionFailed": "Échec du cryptage du nom du sujet. Veuillez vérifier les paramètres de sécurité.",
  "productRegistration.navigation.next": "Vers l'extraction de critères",
  "productRegistration.directRubric.title": "Créer une rubrique directement",
  "productRegistration.directRubric.description": "Vous pouvez également ignorer l'extraction de critères et créer une rubrique manuellement.",
  "productRegistration.directRubric.button": "Aller à la création manuelle de rubrique",
  "productRegistration.nextButton": "Vers l'extraction de critères",
  "productRegistration.error.decryptionLog": "Erreur de décryptage pour le sujet {{index}} :",
  "productRegistration.error.decryptionDisplay": "[Erreur de décryptage]",
  "productRegistration.error.encryptionLog": "Erreur de cryptage du nom du sujet :",
  "productRegistration.error.encryptionAlert": "Échec du cryptage du nom du sujet. Veuillez vérifier les paramètres de sécurité.",
  "productRegistration.error.csvAlert": "Le fichier CSV doit avoir les colonnes reviewTitle et reviewComment. Veuillez télécharger le modèle et vérifier.",
  "productRegistration.csv.exampleTitle1": "Nom du sujet 1",
  "productRegistration.csv.exampleDetail1": "Description détaillée 1",
  "productRegistration.csv.exampleTitle2": "Nom du sujet 2",
  "productRegistration.csv.exampleDetail2": "Description détaillée 2",
  "productRegistration.csv.exampleTitle3": "Nom du sujet 3",
  "productRegistration.csv.exampleDetail3": "Description détaillée 3",

  // Comparison Evaluation
  "comparisonEvaluation.emptyState.title": "Veuillez d'abord définir les sujets d'évaluation et les critères",
  "comparisonEvaluation.emptyState.description": "Les sujets d'évaluation et les critères sont tous deux requis pour l'évaluation comparative.",
  "comparisonEvaluation.emptyState.backToProducts": "Retour à l'enregistrement des sujets",
  "comparisonEvaluation.emptyState.backToCriteria": "Retour à l'extraction des critères",
  "comparisonEvaluation.title": "Classons-en quelques-uns par ordre de qualité",
  "comparisonEvaluation.description": "",
  "comparisonEvaluation.criterionSelector.title": "Sélectionner le critère d'évaluation",
  "comparisonEvaluation.productsPanel.title": "Sujets d'évaluation",
  "comparisonEvaluation.productsPanel.hint": "Faites glisser pour positionner sur la ligne numérique",
  "comparisonEvaluation.evaluationLine.low": "Mauvais",
  "comparisonEvaluation.evaluationLine.high": "Bon",
  "comparisonEvaluation.evaluationLine.hint": "Vous pouvez faire glisser et repositionner les éléments placés",
  "comparisonEvaluation.progress.prefix": "Progression : ",
  "comparisonEvaluation.progress.suffix": " / {{total}} placés",
  "comparisonEvaluation.progress.completed": "✅ Toutes les évaluations terminées",
  "comparisonEvaluation.options.title": "Sélectionner la méthode de placement",
  "comparisonEvaluation.options.description": "Vous pouvez choisir de placer tous les éléments en une fois ou d'utiliser le mode rapide pour les placer un par un après la création de la rubrique.",
  "comparisonEvaluation.options.quickModeButton": "Utiliser le mode d'évaluation rapide",
  "comparisonEvaluation.options.quickModeNote": "※ Mode simple pour placer un par un après la création de la rubrique",
  "comparisonEvaluation.nextButton": "Vers l'attribution des notes",
  "comparisonEvaluation.prevButton": "Retour à l'extraction des critères",

  // Grade Assignment
  "gradeAssignment.emptyState.title": "Veuillez terminer l'évaluation",
  "gradeAssignment.emptyState.description": "L'évaluation comparative doit être terminée pour définir les notes.",
  "gradeAssignment.emptyState.backButton": "Retour à l'évaluation comparative",
  "gradeAssignment.title": "Attribution des notes",
  "gradeAssignment.description": "Pour chaque critère, faites glisser les limites de notes pour les ajuster.",
  "gradeAssignment.criterionSelector.title": "Sélectionner le critère",
  "gradeAssignment.gradeSuffix": "notes",
  "gradeAssignment.gradeSettings.titleSuffix": " Paramètres de notes",
  "gradeAssignment.editGradesButton": "Modifier les notes",
  "gradeAssignment.boundaries.title": "Ajustement des limites de notes",
  "gradeAssignment.boundaries.description": "Faites glisser les lignes de limite pour ajuster les plages de notes",
  "gradeAssignment.distribution.title": "Distribution des notes",
  "gradeAssignment.table.grade": "Note",
  "gradeAssignment.table.count": "Nombre",
  "gradeAssignment.table.percentage": "Pourcentage",
  "gradeAssignment.table.subjects": "Sujets d'évaluation",
  "gradeAssignment.table.tooltip": "Double-cliquez pour afficher les détails",
  "gradeAssignment.nextButton": "Vers la génération de rubrique",
  "gradeAssignment.prevButton": "Retour à l'évaluation comparative",
  "gradeAssignment.modal.title": "Modifier les notes",
  "gradeAssignment.modal.gradeNamesTitle": "Définir les noms de notes",
  "gradeAssignment.modal.gradeLabel": "Note {{index}}",
  "gradeAssignment.modal.deleteButton": "Supprimer",
  "gradeAssignment.modal.addGradeButton": "Ajouter une note",
  "gradeAssignment.modal.doneButton": "Terminé",
  "gradeAssignment.status.notEvaluated": "Non évalué",
  "gradeAssignment.status.notSet": "Non défini",
  "gradeAssignment.saveSuccess": "Données d'évaluation enregistrées !",
  "rubricGeneration.emptyState.title": "Veuillez terminer l'attribution des notes",
  "rubricGeneration.emptyState.description": "L'attribution des notes doit être terminée avant de générer des rubriques.",
  "rubricGeneration.emptyState.backButton": "Retour à l'attribution des notes",
  "rubricGeneration.title": "Génération de rubriques",
  "rubricGeneration.description": "Créez des rubriques détaillées en analysant les différences entre les travaux les mieux notés.",
  "rubricGeneration.progress.title": "Progression de l'analyse des différences de limites de notes",
  "rubricGeneration.progress.criteriaComplete": "critères terminés",
  "rubricGeneration.progress.boundaryComplete": "limites terminées",
  "rubricGeneration.question.criterionLabel": "Critère :",
  "rubricGeneration.question.gradeSuffix": "Note",
  "rubricGeneration.question.moreCount": "+{{count}} autres",
  "rubricGeneration.question.title": "Quelles différences avez-vous remarquées entre les travaux de note {{upperGrade}} et de note {{lowerGrade}} pour le critère \"{{criterion}}\" ?",
  "rubricGeneration.question.placeholder": "Exemple : Les travaux de note {{upperGrade}} ont une structure logique claire avec des données de support abondantes. Les travaux de note {{lowerGrade}} ont de bons arguments mais manquent d'exemples spécifiques et de pouvoir de persuasion.",
  "rubricGeneration.question.addButton": "Ajouter une différence",
  "rubricGeneration.question.recordedDifferences": "Différences enregistrées :",
  "rubricGeneration.question.deleteButton": "Supprimer",
  "rubricGeneration.question.completeButton": "Terminer cette analyse de limite",
  "rubricGeneration.summary.title": "Résumé de l'analyse des limites de notes",
  "rubricGeneration.summary.boundaryTitle": "Limite {{upperGrade}}-{{lowerGrade}}",
  "rubricGeneration.summary.differencesCount": "{{count}} différences enregistrées",
  "rubricGeneration.generation.generating": "Génération de la rubrique...",
  "rubricGeneration.generation.generateButton": "Générer une rubrique IA",
  "rubricGeneration.display.title": "Rubrique générée",
  "rubricGeneration.display.description": "Rubrique détaillée créée à partir des informations de différence analysées par l'IA.",
  "rubricGeneration.display.regenerateButton": "Régénérer",
  "rubricGeneration.navigation.nextToQuick": "Vers l'évaluation rapide",
  "rubricGeneration.navigation.backToGrade": "Retour à l'attribution des notes",
  "rubricGeneration.error.generation": "Une erreur s'est produite lors de la génération de la rubrique",

  // Progress Bar
  "progressBar.label": "Progression de l'évaluation",
  "progressBar.messages.criteriaSetup": "La définition des critères complète 15%",
  "progressBar.messages.completed": "🎉 Évaluation terminée !",
  "progressBar.messages.progress": "Produits : {{products}} × Critères : {{criteria}} = {{total}} évaluations",

  // Evaluation Header
  "evaluationHeader.placeholder": "Entrez le titre de l'évaluation",
  "evaluationHeader.saveTitle": "Enregistrer",
  "evaluationHeader.cancelTitle": "Annuler",
  "evaluationHeader.untitled": "Évaluation sans titre",
  "evaluationHeader.editTitle": "Modifier le titre",

  // Draggable Product Card
  "draggableProductCard.detailsCount": "Détails : {{count}} caractères",
  "draggableProductCard.previewAvailable": "🔗 Aperçu disponible",
  "draggableProductCard.showPreview": "Afficher l'aperçu",
  "draggableProductCard.editDetails": "Modifier les détails",
  "draggableProductCard.position": "Position : {{value}}",
  "draggableProductCard.rank": "Rang : {{value}}",
  "draggableProductCard.placed": "Placé",

  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.title": "Mode d'évaluation rapide",
  "comparativeEvaluationQuick.criterionSelector.title": "Sélectionner le critère d'évaluation",
  "comparativeEvaluationQuick.productsPanel.title": "Éléments d'évaluation",
  "comparativeEvaluationQuick.productsPanel.currentlyEvaluating": "Évaluation en cours :",
  "comparativeEvaluationQuick.nextButton": "Suivant",
  "comparativeEvaluationQuick.prevButton": "Retour",
  "comparativeEvaluationQuick.grades.excellent": "Excellent",
  "comparativeEvaluationQuick.grades.good": "Bon",
  "comparativeEvaluationQuick.grades.average": "Moyen",
  "comparativeEvaluationQuick.grades.needsImprovement": "À améliorer",
  "comparativeEvaluationQuick.completion.title": "Évaluation terminée",
  "comparativeEvaluationQuick.completion.subtitle": "Les {{count}} éléments ont été évalués",
  "comparativeEvaluationQuick.completion.evaluationCount": "Éléments évalués",
  "comparativeEvaluationQuick.completion.criteriaCount": "Critères d'évaluation",
  "comparativeEvaluationQuick.completion.viewResults": "Voir les résultats",
  "comparativeEvaluationQuick.completion.detailAdjustment": "Ajustement détaillé",
  "comparativeEvaluationQuick.criterionComplete.title": "\"{{criterion}}\" terminé",
  "comparativeEvaluationQuick.criterionComplete.subtitle": "{{count}} éléments évalués",
  "comparativeEvaluationQuick.criterionComplete.nextCriterion": "Critère suivant : ",
  "comparativeEvaluationQuick.criterionComplete.proceedToNext": "Passer au critère suivant",
  "comparativeEvaluationQuick.criterionComplete.allComplete": "Toutes les évaluations de critères sont terminées",
  "comparativeEvaluationQuick.criterionComplete.viewResults": "Voir les résultats",
  "comparativeEvaluationQuick.empty.title": "Aucune donnée à évaluer",
  "comparativeEvaluationQuick.empty.description": "Veuillez configurer les produits et les critères d'évaluation.",
  "comparativeEvaluationQuick.header.doubleClickToView": "Double-cliquez pour voir les détails",
  "comparativeEvaluationQuick.header.progress": "{{completed}} / {{total}} terminés",
  "comparativeEvaluationQuick.header.criterionProgress": "({{current}} / {{total}} critères)",
  "comparativeEvaluationQuick.navigation.nextCriterion": "Critère suivant : {{name}}",
  "comparativeEvaluationQuick.progress.remaining": "{{count}} restants",
  "comparativeEvaluationQuick.gradeExplanation.instruction": "Cliquez n'importe où de gauche (D : À améliorer) à droite (A : Excellent) pour placer votre évaluation.",
  "comparativeEvaluationQuick.gradeExplanation.currentPosition": " Position actuelle : {{grade}} ({{description}})",
  "comparativeEvaluationQuick.actions.switchToAllMode": "Passer au mode placement complet",
  "comparativeEvaluationQuick.shortcuts.enterNext": "Appuyez sur Entrée pour passer au critère suivant",
  "comparativeEvaluationQuick.shortcuts.spaceSkip": "Appuyez sur Espace pour passer au critère suivant",
  "comparativeEvaluationQuick.criterion.instruction": "Jugez la supériorité selon ce critère",

  // Grade Assignment
  "gradeAssignment.modal.gradePlaceholder": "Entrez le nom de la note",
  "gradeAssignment.boundaryLabel": "Limite {{upper}}・{{lower}}",
  "gradeAssignment.doubleClickToView": "Double-cliquez pour voir les détails",
  "gradeAssignment.dragBoundaryHint": "Faites glisser les limites pour ajuster les plages de notes",
  "gradeAssignment.percentAbove": "{{percent}}% ou plus est {{grade}}",
  "gradeAssignment.gradeNumber": "Note {{number}}",
  "gradeAssignment.grade": "Note",

  // Evaluation Page
  "evaluation.noDataToSave": "Aucune donnée à enregistrer",
  "evaluation.dataSaved": "Données enregistrées avec succès !",
  "evaluation.saveFailed": "Échec de l'enregistrement",
  "evaluation.saveError": "Erreur lors de l'enregistrement",
  "evaluation.failedKeyword": "Échec",
  "evaluation.errorKeyword": "Erreur",
  "evaluation.saving": "💾 Enregistrement...",

  // Product Registration
  "productRegistration.registeredItems": "Objets d'évaluation enregistrés ({{count}})",
  "productRegistration.encryptedBadge": "🔒 Chiffré",
  "productRegistration.encryptedTitle": "Chiffré",
  "productRegistration.previewTitle": "Aperçu de {{title}}",
  "productRegistration.editTitle": "Modifier {{title}}",
  "productRegistration.deleteTitle": "Supprimer {{title}}",

  // CSV Export
  "csvExport.export": "Export CSV",
  
  // Missing translations
  "evaluation.loadError": "Échec du chargement du projet",
  "evaluation.loadingProject": "Chargement du projet en cours...",
  
  // Invitation page
  "invitation.invalidOrExpired": "Invitation invalide ou expirée",
  "invitation.invalidTitle": "Invitation invalide",
  "invitation.invalidDescription": "Ce lien d'invitation est invalide.",
  "invitation.backToDashboard": "Retour au tableau de bord",
  "invitation.acceptedTitle": "Invitation acceptée",
  "invitation.acceptedDescription": "Vous avez rejoint la collaboration avec succès.",
  "invitation.redirecting": "Redirection vers le tableau de bord...",
  "invitation.goToDashboard": "Aller au tableau de bord",
  "invitation.description": "Vous avez reçu une invitation de collaboration pour un projet.",
  "invitation.acceptQuestion": "Souhaitez-vous accepter cette invitation ?",
  "invitation.processing": "Traitement en cours...",
  "invitation.decline": "Refuser",
  "invitation.capabilitiesTitle": "Permissions du collaborateur",
  "invitation.capability1": "Voir et modifier les projets",
  "invitation.capability2": "Effectuer et modifier les évaluations",
  "invitation.capability3": "Générer et exporter des rapports",
  "invitation.capability4": "Inviter d'autres membres",
  "invitation.capability5": "Modifier les paramètres du projet",
  
  // RubricGeneration
  "rubricGeneration.generation.generatingDescription": "Analyse des critères et des produits pour générer la rubrique d'évaluation optimale...",
  "rubricGeneration.generation.step1": "Analyse des critères d'évaluation",
  "rubricGeneration.generation.step2": "Analyse des caractéristiques du produit",
  "rubricGeneration.generation.step3": "Génération de la rubrique d'évaluation",
  "rubricGeneration.criterionSelector.title": "Sélectionner les critères",
  "rubricGeneration.display.editCellAria": "Modifier la cellule",
  
  // Report
  "report.noRubricDescriptions": "Aucune description de rubrique disponible",
  "report.commentGenerationFailed": "Échec de la génération du commentaire",
  "report.allEvaluations": "Toutes les évaluations",
  "preview.openInNewTab": "Ouvrir dans un nouvel onglet",
  "report.generateComment": "Générer un commentaire",
  "report.pdfGeneration.generating": "Génération du PDF",
  "report.pdfGeneration.generatingDescription": "Création des rapports PDF pour tous les produits...",
  "report.pdfGeneration.step1": "Collecte des données d'évaluation",
  "report.pdfGeneration.step2": "Génération de la mise en page PDF",
  "report.pdfGeneration.step3": "Finalisation du rapport",
  "report.generatingPdf": "Génération du PDF en cours...",
  "report.downloadAllPdf": "Télécharger tous les PDF",
  "report.backToQuick": "Retour à l'évaluation rapide",
  "report.generatingPdfDescription": "Génération du rapport PDF. Cela peut prendre un moment...",
  "report.pdfStep1": "Collecte des données d'évaluation",
  "report.pdfStep2": "Création de la mise en page PDF",
  "report.pdfStep3": "Finalisation du rapport",
  
  // Product Registration
  "productRegistration.error.encryptionError": "Une erreur de chiffrement s'est produite",
  "productRegistration.quickInput.placeholder": "Entrez les noms ou détails des produits (un par ligne)",
  "productRegistration.quickInput.hint": "Vous pouvez coller plusieurs éléments à la fois. Les lignes vides seront ignorées.",
  "productRegistration.quickInput.disable": "Passer en mode de saisie détaillée",
  "productRegistration.quickInput.enable": "Passer en mode de saisie rapide",
  "productRegistration.mode.detailed": "Mode détaillé",
  "productRegistration.mode.quick": "Mode rapide",
  "productRegistration.quickInput.collectDetails": "Collecter les détails",
  "productRegistration.emptyHint": "Ajoutez au moins un produit pour continuer",
  "productRegistration.form.modalTitle": "Modifier le produit",
  
  // Grade Assignment
  "gradeAssignment.distribution.doubleClickToView": "Double-cliquez pour voir les détails",
  
  // Criteria Extraction
  "criteriaExtraction.inputFormTitle": "Saisie des critères d'évaluation",
  "criteriaExtraction.inputFormSubtitle": "Entrez les critères d'évaluation pour votre évaluation",
  "criteriaExtraction.productDescriptionsLabel": "Descriptions des produits",
  "criteriaExtraction.productDescriptionPlaceholder": "Entrez la description du produit...",
  "criteriaExtraction.removeDescription": "Supprimer la description",
  "criteriaExtraction.criteriaListTitle": "Liste des critères d'évaluation",
  "criteriaExtraction.criterionTitlePlaceholder": "Entrez le titre du critère",
  "criteriaExtraction.criterionDescriptionPlaceholder": "Entrez la description du critère",
  "criteriaExtraction.addCriterionCard": "Ajouter un nouveau critère",
  "criteriaExtraction.editCriterion": "Modifier le critère",
  "criteriaExtraction.deleteCriterion": "Supprimer le critère",
  "criteriaExtraction.extracting": "Extraction des critères",
  "criteriaExtraction.extractingDescription": "Analyse de votre saisie pour extraire les critères d'évaluation...",
  "criteriaExtraction.step1": "Analyse du contenu",
  "criteriaExtraction.step2": "Identification des critères clés",
  "criteriaExtraction.step3": "Organisation des résultats",
  "criteriaExtraction.quickInputPlaceholder": "Entrez les critères d'évaluation ou collez du contenu pour extraire les critères...",
  "criteriaExtraction.addCriterionModalTitle": "Ajouter un nouveau critère",
  "criteriaExtraction.criterionTitleLabel": "Titre du critère",
  "criteriaExtraction.criterionDescriptionsLabel": "Descriptions du critère",
  "criteriaExtraction.removeCriterionDescription": "Supprimer la description",
  "criteriaExtraction.addCriterionDescriptionButton": "Ajouter une description",
  "criteriaExtraction.addCriterionConfirmButton": "Ajouter le critère",
  
  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.cursor.nextStep": "Passer à l'étape suivante",
  "comparativeEvaluationQuick.cursor.nextCriterion": "Passer au critère suivant",
  
  // Preview
  "preview.loadErrorDetail": "Échec du chargement de l'aperçu",
  "preview.invalidUrl": "URL invalide",
  "preview.invalidUrlDetail": "Veuillez entrer une URL valide",
  "preview.loading": "Chargement...",
  "preview.loadError": "Échec du chargement",
  "preview.pageLoadError": "La page n'a pas pu être chargée",
  "preview.comment": "Commentaire",
  "preview.commentPlaceholder": "Ajoutez votre commentaire...",
  
  // Google Drive
  "googleDrive.searchPlaceholder": "Rechercher des fichiers...",
  "googleDrive.allTypes": "Tous les types",
  "googleDrive.documents": "Documents",
  "googleDrive.spreadsheets": "Feuilles de calcul",
  "googleDrive.presentations": "Présentations",
  "googleDrive.sortByName": "Nom",
  "googleDrive.sortByModified": "Modifié",
  "googleDrive.searchResults": "Résultats de recherche pour \"{{query}}\"",
  "googleDrive.selectAll": "Tout sélectionner",
  "googleDrive.clearSelection": "Effacer la sélection",
  "common.folder": "Dossier",
  "googleDrive.noSearchResults": "Aucun résultat trouvé",
  
  // Dashboard
  "dashboard.enterProjectName": "Entrez le nom du projet",
  
  // AutoSave
  "autoSave.enable": "Activer la sauvegarde automatique",
  "autoSave.currentSetting": "Paramètre actuel :",
  "autoSave.descriptionShort": "Les données sont sauvegardées automatiquement",
  "autoSave.descriptionLocal": "Également sauvegardé dans le stockage local",
  "autoSave.descriptionError": "Les données sont préservées en cas d'erreur",
  
  // Weight
  "weight.currentTotal": "Total actuel :",
  
  // CSV Export
  "csvExport.templateRequired": "Veuillez entrer un modèle",
  "csvExport.exportFailed": "Échec de l'exportation",
  "csvExport.sampleComment": "Ceci est un commentaire exemple",
  "csvExport.currentUser": "Utilisateur actuel",
  "csvExport.title": "Export CSV",
  "csvExport.exportStatus": "Statut d'exportation",
  "csvExport.remaining": "Restant :",
  "csvExport.unlimited": "Illimité",
  "csvExport.templateLabel": "Modèle d'exportation",
  "csvExport.templatePlaceholder": "Entrez votre modèle...",
  "csvExport.templateHelp": "Créez un modèle en utilisant les variables disponibles",
  "csvExport.availablePlaceholders": "Variables disponibles",
  "csvExport.preview": "Aperçu",
  "csvExport.filename": "Nom du fichier",
  "csvExport.format": "Format",
  "csvExport.includeHeader": "Inclure l'en-tête",
  "csvExport.exporting": "Exportation en cours...",
  
  // Rubric Generation Dialog
  "rubricGeneration.differenceDialog.title": "Expliquer les différences",
  "rubricGeneration.differenceDialog.progress": "Question {{current}} sur {{total}}",
  "rubricGeneration.differenceDialog.question": "Qu'est-ce qui distingue \"{{gradeA}}\" de \"{{gradeB}}\" pour {{criterion}} ?",
  "rubricGeneration.differenceDialog.hint": "Veuillez décrire les différences spécifiques entre ces niveaux d'évaluation.",
  "rubricGeneration.differenceDialog.placeholder": "Par exemple : Le niveau A montre une compréhension complète tandis que le niveau B montre une compréhension partielle...",
  "rubricGeneration.differenceDialog.skipAndGenerate": "Ignorer et générer",
  "rubricGeneration.differenceDialog.skip": "Ignorer",
  "rubricGeneration.differenceDialog.completeAndGenerate": "Terminer et générer",
  "rubricGeneration.differenceDialog.next": "Suivant",
  
  // Product Registration
  "productRegistration.noDetailProvided": "Aucun détail fourni",
  "productRegistration.detailsDialog.title": "Détails du produit",
  "productRegistration.detailsDialog.progress": "Produit {{current}} sur {{total}}",
  "productRegistration.detailsDialog.productTitle": "{{title}}",
  "productRegistration.detailsDialog.detailLabel": "Détails",
  "productRegistration.detailsDialog.detailPlaceholder": "Entrez les détails ou la description du produit...",
  "productRegistration.detailsDialog.linkLabel": "Lien de référence (optionnel)",
  "productRegistration.detailsDialog.linkPlaceholder": "https://example.com/product",
  "productRegistration.detailsDialog.hint": "Fournissez des détails pour aider à l'évaluation. Vous pouvez ignorer si ce n'est pas nécessaire.",
  "productRegistration.detailsDialog.skipAndComplete": "Tout ignorer et terminer",
  "productRegistration.detailsDialog.skip": "Ignorer",
  "productRegistration.detailsDialog.complete": "Terminer",
  "productRegistration.detailsDialog.next": "Suivant",
  "productRegistration.edit.modalTitle": "Modifier le produit",
  
  // Criteria Extraction Modal
  "criteriaExtraction.edit.modalTitle": "Modifier le critère",
  "criteriaExtraction.form.titleLabel": "Titre",
  "criteriaExtraction.edit.titlePlaceholder": "Entrez le titre du critère",
  "criteriaExtraction.form.descriptionLabel": "Description",
  "criteriaExtraction.edit.descriptionPlaceholder": "Entrez la description du critère",
  "criteriaExtraction.form.addDescription": "Ajouter une description",
  "criteriaExtraction.edit.save": "Enregistrer",
  "criteriaExtraction.edit.cancel": "Annuler",
  
  // Grade Assignment
  "gradeAssignment.dragOrDoubleClick": "Faites glisser les limites ou double-cliquez sur les produits pour ajuster",
  
  // Product Registration Import
  "productRegistration.import.sectionTitle": "Importer",
  "productRegistration.import.googleDrive": "Google Drive",
  "productRegistration.import.localTitle": "Importer depuis des fichiers locaux",
  "productRegistration.import.localLabel": "Importer depuis des fichiers locaux",
  "productRegistration.import.local": "Fichiers locaux",
  
  // Final missing translations
  "productRegistration.import.csvShort": "CSV",
  "productRegistration.export.sectionTitle": "Exporter",
  "productRegistration.export.template": "Modèle",
  "localFolderBrowser.loading": "Chargement...",
  "localFolderBrowser.loadingWithFile": "Chargement de {{file}}...",
  "localFolderBrowser.title": "Sélectionner des fichiers locaux",
  "localFolderBrowser.searchPlaceholder": "Rechercher des fichiers...",
  "localFolderBrowser.selectAll": "Tout sélectionner",
  "localFolderBrowser.clearSelection": "Effacer la sélection",
  "localFolderBrowser.selectedCount": "{{count}} sélectionné(s)",
  "localFolderBrowser.noFilesFound": "Aucun fichier trouvé",
  "localFolderBrowser.dropzone.text": "Glissez-déposez des fichiers ici ou cliquez pour sélectionner",
  "localFolderBrowser.dropzone.acceptedFormats": "Formats acceptés : .txt, .csv, .docx, .pdf, .xlsx",
  "localFolderBrowser.cancel": "Annuler",
  "localFolderBrowser.import": "Importer",
  
  // Evaluation guidance messages
  "evaluation.guidance.registerProducts": " Veuillez enregistrer les produits à évaluer",
  "evaluation.guidance.completeRegistration": " Complétez l'enregistrement des produits et cliquez sur 'Suivant'",
  "evaluation.guidance.extractCriteria": " Veuillez extraire ou ajouter manuellement les critères d'évaluation",
  "evaluation.guidance.confirmCriteria": " Vérifiez et modifiez les critères, puis cliquez sur 'Suivant'",
  "evaluation.guidance.placeProducts": "💡 Placez au moins {{count}} produits pour chaque critère",
  "evaluation.guidance.placeMoreProducts": "💡 Placez {{remaining}} produits supplémentaires pour le critère '{{criterionTitle}}'",
  "evaluation.guidance.comparisonComplete": " Comparaisons requises terminées. Cliquez sur 'Suivant' pour procéder à l'attribution des notes",
  "evaluation.guidance.setGrades": "💡 Veuillez définir les notes (A, B, C, etc.) pour '{{criterionTitle}}'",
  "evaluation.guidance.gradesComplete": " Attribution des notes terminée. Cliquez sur 'Suivant' pour générer la grille d'évaluation",
  "evaluation.guidance.rubricGenerated": " La grille d'évaluation a été générée. Cliquez sur 'Suivant' pour continuer",
  "evaluation.guidance.generateRubric": " Veuillez générer la grille d'évaluation",
  "evaluation.guidance.startEvaluation": "💡 Commençons l'évaluation ! Cliquez simplement pour placer les éléments",
  "evaluation.guidance.progress25": "💡 Excellent progrès ! Presque à mi-chemin ({{progress}}% complété)",
  "evaluation.guidance.progress50": "💡 Plus de la moitié ! Continuez comme ça ({{progress}}% complété)",
  "evaluation.guidance.progress75": "💡 75% complété ! La ligne d'arrivée est en vue",
  "evaluation.guidance.almostDone": "💡 Presque terminé ! Il ne reste que {{unplacedCount}} éléments",
  "evaluation.guidance.allComplete": " Toutes les évaluations terminées. Cliquez sur 'Suivant' pour générer le rapport",
  "evaluation.guidance.downloadReport": " Veuillez télécharger ou partager le rapport"
};